docReady(function () {
	/*
	Regular accordion
	*/
	if (document.querySelector('.block-accordion')) {
		const setAccordionHeight = (accordionItem) => {
			const content = accordionItem.querySelector('.accordion__item-content');

			if (!content) {
				return;
			}

			content.style.maxHeight = accordionItem.classList.contains('active') ? `${content.scrollHeight}px` : '0px';
		};

		const openAccordionItem = (accordionItem) => {
			accordionItem.classList.add('active');

			window.requestAnimationFrame(() => {
				setAccordionHeight(accordionItem);
			});
		};

		const closeAccordionItem = (accordionItem) => {
			const content = accordionItem.querySelector('.accordion__item-content');

			if (content) {
				content.style.maxHeight = `${content.scrollHeight}px`;
			}

			window.requestAnimationFrame(() => {
				accordionItem.classList.remove('active');
				setAccordionHeight(accordionItem);
			});
		};

		const closeAccordionSiblings = (accordionItem) => {
			const accordion = accordionItem.closest('.block-accordion');

			if (!accordion) {
				return;
			}

			accordion.querySelectorAll('.accordion__item.active').forEach(activeItem => {
				if (activeItem !== accordionItem) {
					closeAccordionItem(activeItem);
				}
			});
		};

		const anchorLinks = document.querySelectorAll('a[href^="#"]');

		anchorLinks.forEach(link => {
			link.addEventListener('click', function (event) {
				event.preventDefault();
				const targetId = this.getAttribute('href').substring(1);
				const target = document.getElementById(targetId);

				if (!target) {
					return;
				}

				// Scroll to the target with smooth behavior
				target.scrollIntoView({
					behavior: 'smooth'
				});

				if (target.classList.contains('block-accordion-item') || target.classList.contains('accordion__item')) {
					closeAccordionSiblings(target);
					openAccordionItem(target)
				}
			});
		});

		document.querySelectorAll('.block-accordion').forEach(accordion => {
			accordion.querySelectorAll('.accordion__item').forEach(accordionTab => {
				setAccordionHeight(accordionTab);

				let trigger = accordionTab.querySelector('.accordion__item-title');

				if (trigger) {
					trigger.addEventListener('click', function (e) {
						e.preventDefault();
						if (accordionTab.classList.contains('active')) {
							closeAccordionItem(accordionTab);
						} else {
							closeAccordionSiblings(accordionTab);
							openAccordionItem(accordionTab);
						}
					})
				}
			});
		});
	}

	/*
	Plots table accordion
	*/
	if (document.querySelector('.js-accordion-plots-table')) {
		let plotsTriggers = document.querySelectorAll('.js-open-plots-accordion');
		if (plotsTriggers) {
			plotsTriggers.forEach(trigger => {
				trigger.addEventListener('click', function (e) {
					console.log('click')
					e.preventDefault();
					trigger.parentElement.classList.contains('active') ? trigger.parentElement.classList.remove('active') : trigger.parentElement.classList.add('active')
				})
			});
		}
	}

	/*
	Alternative accordion
	*/
	// if(document.querySelector('.block-alt-accordion')){
	// 	document.querySelectorAll('.block-alt-accordion').forEach(accordion => {
	// 		let trigger = accordion.querySelector('.js-accordion-trigger');
	// 		trigger.addEventListener('click', function(e){
	// 			if(accordion.classList.contains('expanded')){
	// 				trigger.innerHTML = 'Read more';
	// 			} else {
	// 				trigger.innerHTML = 'Read less';

	// 			}
	// 			accordion.classList.toggle('expanded');
	// 		})
	// 	})
	// }

	if (document.querySelector('.block-alt-accordion')) {
		document.querySelectorAll('.block-alt-accordion').forEach(accordion => {
			let trigger = accordion.querySelector('.js-accordion-trigger');
			let content = accordion.querySelector('.block-alt-accordion__content');

			// Calculate and set the max-height for collapsed state
			let maxHeight = window.getComputedStyle(content).getPropertyValue('height');
			content.style.maxHeight = maxHeight;

			trigger.addEventListener('click', function (e) {
				if (accordion.classList.contains('expanded')) {
					content.style.maxHeight = maxHeight;
					trigger.innerHTML = 'Read more';
				} else {
					content.style.maxHeight = 'none';
					trigger.innerHTML = 'Read less';
				}
				accordion.classList.toggle('expanded');
			});
		});
	}
})
